var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.100098V19.9295H11V0.100098H0ZM1.90681 1.15857H4.36473V3.32408H1.90681V1.15857ZM1.90681 4.7807H4.36473V6.9462H1.90681V4.7807ZM1.90681 8.25716H4.36473V10.4227H1.90681V8.25716ZM1.90681 11.7336H4.36473V13.8991H1.90681V11.7336ZM6.78958 19.6188H4.18838V16.0064H6.78958V19.6188ZM9.43487 13.8991H6.97695V11.7336H9.43487V13.8991ZM9.43487 10.4227H6.97695V8.25716H9.43487V10.4227ZM9.43487 6.9462H6.97695V4.7807H9.43487V6.9462ZM9.43487 3.32408H6.97695V1.15857H9.43487V3.32408Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.44922V19.9294H20V8.44922H12ZM13.3868 10.2245H15.1743V12.025H13.3868V10.2245ZM13.3868 13.115H15.1743V14.9155H13.3868V13.115ZM16.9379 19.671H15.0461V16.6675H16.9379V19.671ZM18.8617 14.9155H17.0741V13.115H18.8617V14.9155ZM18.8617 12.025H17.0741V10.2245H18.8617V12.025Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings);
export default __webpack_public_path__ + "static/media/buildings.becf5268a131a885202f47e1c199568c.svg";
export { ForwardRef as ReactComponent };